import App, { AppContext } from 'next/app'

import cookies from 'next-cookies'
import { isBrowser } from 'com-ui/utilities/ssr'

export const EXCLUDED_ROUTER = ['/login', '/register', '/validate-otp']

export const isExcludedRouter = (pathName: string) => EXCLUDED_ROUTER.some((path) => pathName.startsWith(path))

interface IWithAuthProps {
  location: string
  jwtCookieKey: string
}

const serverSideAuthHandler = (appContext: AppContext, redirectLocation: string, jwtCookieKey: string) => {
  const { ctx, router } = appContext

  if (!isBrowser() && ctx) {
    console.log('jwtCookieKey: ', jwtCookieKey);
    const jwtToken = cookies(ctx)?.[jwtCookieKey]
    console.log('jwtToken: ', cookies(ctx));
    try {
      if (!jwtToken) {
        if (!isExcludedRouter(router.pathname) && ctx.res) {
          ctx.res.writeHead(302, { Location: `${redirectLocation}?return_url=${router.asPath}stream/campaign` })
          ctx.res.end()
          return
        }
      } else {
        if (isExcludedRouter(router.pathname) && ctx.res) {
          ctx.res.writeHead(302, { Location: '/' })
          ctx.res.end()
          return
        }
      }
    } catch (err) {
      throw new Error(err)
    }
  }
}

// TODO Be considered to implement in future
// const clientSideAuthHandler = (redirectLocation: string, jwtCookieKey: string) => {
//   const router = useRouter()
//   if (isBrowser()) {
//     try {
//       const jwtCookie = cookieCutter(document).get(jwtCookieKey)
//       if (!jwtCookie) {
//         if (!router.pathname.includes(redirectLocation)) {
//           router.push(`${redirectLocation}?return_url=${router.asPath}`)
//           throw new Error(`The JWT cannot be found or is expired, redirect to ${redirectLocation}`)
//         }
//       } else {
//         if (router.pathname.includes(redirectLocation)) {
//           router.push('/')
//           return <></>
//         }
//       }
//     } catch (err) {
//       console.log(err)
//     }
//   }
// }

/**
 * Require the user to be authenticated in order to render the component.
 * If the user isn't authenticated, forward to the given URL.
 */
const withAuth = (WrappedComponent: any, props: IWithAuthProps = { location: '/login', jwtCookieKey: '' }) => {
  const WithAuthWrapper = (props: any) => {
    //TODO will be considered implementing in the future
    // clientSideAuthHandler(props.location, props.jwtCookieKey)
    return WrappedComponent({ ...props })
  }

  WithAuthWrapper.getInitialProps = async (appContext: AppContext) => {
    console.log('props.jwtCookieKey: ', props.jwtCookieKey);
    serverSideAuthHandler(appContext, props.location, props.jwtCookieKey)

    const componentProps = WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(appContext))
    const appProps = App.getInitialProps && (await App.getInitialProps(appContext))

    return { ...componentProps, ...appProps }
  }

  return WithAuthWrapper
}

export { withAuth }
